import React from 'react';
import {
  KeyBenefitItem,
  ProductTypeCustomisation
} from '../../common/CommonTypes';
import { CommonValidation } from '../../common/CommonValidation/commonValidation';

export type ProductSectionItemProps = {
  product: ProductTypeCustomisation;
  index: number;
};

const ProductSectionItem = ({
  product,
  index
}: ProductSectionItemProps): JSX.Element => {
  const getAlt = () => {
    return 'icon-' + index;
  };

  const getKeyBenefits = () => {
    const keyBenefits = product.seeMoreItems.filter(
      (kb) => kb.hideOnLandingPage !== true
    );

    return keyBenefits.map((item: KeyBenefitItem, kbIndex) => (
      <li
        className='key-benefit-item m05-bottom'
        key={`key-benefit-${index}-${kbIndex}`}>
        {item.text}
      </li>
    ));
  };

  const showMedia = () => {
    if (CommonValidation.isNotEmpty(product.videoUrl)) {
      return (
        <video
          data-testid='video-player'
          className='video-player player-wrapper'
          preload='auto'
          controls
          src={product.videoUrl}
        />
      );
    } else {
      return (
        <img
          className='product-image'
          src={product.imageUrl}
          alt='alternative image'
        />
      );
    }
  };

  return (
    <div className='flex-row mobile-column m2-bottom product-section-item'>
      <div className='flex-column product-section-text-column'>
        <p className='p3 m1-bottom'>
          <img
            className='product-item-icon'
            src={product.icon}
            alt={getAlt()}
          />
          <span className='h4 product-item-name m1-left'>{product.name}</span>
        </p>
        <p className='p3 m05-bottom product-item-synopsis'>
          {product.synopsisText}
        </p>
        <ul>{getKeyBenefits()}</ul>
      </div>
      <div className='flex-column product-section-media-column'>
        {showMedia()}
      </div>
    </div>
  );
};

export default ProductSectionItem;
